import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const DEFAULTS = {
  nome_sistema: 'Aulas da Mema',
  logo_url: null,
  cor_accent: null,
  contato_telefone: '',
  contato_email: '',
  contato_endereco: '',
};

export const ConfigContext = createContext(DEFAULTS);

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULTS);

  function applyAccent(cor) {
    if (cor) {
      document.documentElement.style.setProperty('--accent', cor);
    } else {
      document.documentElement.style.removeProperty('--accent');
    }
  }

  function carregar() {
    axios.get(`${API_URL}/configuracoes`, { withCredentials: true })
      .then(r => {
        setConfig({ ...DEFAULTS, ...r.data });
        applyAccent(r.data.cor_accent);
      })
      .catch(() => {});
  }

  useEffect(() => { carregar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ConfigContext.Provider value={{ config, carregar }}>
      {children}
    </ConfigContext.Provider>
  );
}

export const useConfig = () => useContext(ConfigContext);
